import React from "react";
import SettingsForm from "../SettingsForm";

const fields = [
  { heading: "Banner buttons" },
  { key: "register_button", label: "Register button", hint: "Shown on the banner to visitors who are not signed in." },
  { key: "buyer_button", label: "Post a Job button", hint: "Shown on the banner to signed-in members." },
  { key: "find_seller_button", label: "Find Seller button", hint: "Opens the seller search window, with its filters open." },
  { heading: "Find Seller window" },
  { key: "sellers_heading", label: "Heading" },
  { key: "sellers_intro", label: "Intro text", type: "textarea" },
  { heading: "Jobs board" },
  { key: "jobs_heading", label: "Heading" },
  { key: "jobs_intro", label: "Intro text", type: "textarea" },
  { key: "categories", label: "Job categories (one per line)", type: "textarea", rows: 8, hint: "Buyers pick one when posting a job; visitors can filter by it." },
  { key: "currency_label", label: "Currency label", hint: "Shown before every amount, e.g. USD, PKR, AED." },
  { heading: "Sign in / register window" },
  { key: "auth_login_title", label: "Sign in - title" },
  { key: "auth_login_text", label: "Sign in - text", type: "textarea" },
  { key: "auth_register_title", label: "Register - title" },
  { key: "auth_register_text", label: "Register - text", type: "textarea" },
  { heading: "AI assistant (signed-in buyers and sellers)" },
  { key: "ai_enabled", label: "AI assistant", type: "checkbox", checkboxLabel: "Enabled - members see \"AI Assistant\" in their sidebar",
    hint: "The assistant answers with Claude when the server has an ANTHROPIC_API_KEY, otherwise with a basic built-in helper." },
  { key: "ai_name", label: "Assistant name" },
  { key: "ai_welcome", label: "Welcome message", type: "textarea" },
];

export default function CoWorkContentSettings() {
  return (
    <SettingsForm
      endpoint="/core/cowork/settings/"
      title="Marketplace Content"
      intro="The texts of the Co-Work marketplace: banner buttons, the seller search, the jobs board, the sign in / register window and the AI assistant. The banner slides and the browser title, favicon and logo are managed under the other Co-Work menu items."
      fields={fields}
    />
  );
}
